// "A Klaviyo is küld" on or off for one country (0045, owner 2026-10-23), with
// its reason, through the same route as before. One component, so the country
// list on top and the handover panel in "Részletek" ask the same question in
// the same words. Switching it redoes the SES account's split at once (2.2).

import { setHandoverParallel } from "@/lib/api";
import type { Handover } from "@/lib/api";
import { ActionDialog } from "@/components/emc/ActionDialog";
import { PARALLEL } from "@/pages/warmup/handover";

// The API's note limit (`HandoverNoteIn`).
const NOTE_MAX = 500;

interface Props {
  row: Handover;
  /** What the switch goes to: on (parallel) or off (the handover's filter back). */
  enabled: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDone: (message: string) => void;
}

export function ParallelDialog({ row, enabled, open, onOpenChange, onDone }: Props) {
  if (enabled) {
    return (
      <ActionDialog
        open={open}
        onOpenChange={onOpenChange}
        title={`${row.country}: a Klaviyo is küld (párhuzamos)`}
        description={
          <>
            A(z) {row.country} Klaviyo-fiókja továbbra is mindenkinek küld, és innen is: a futó és az
            új kampányok hullámtól függetlenül küldenek, ugyanaz a kontakt mindkettőtől kaphat
            levelet. Minden más kizárás, a gyakorisági korlát és a napi keret él. N megmarad
            (most {row.wave}); kikapcsolva újra az átadás-szűrés dönt.
          </>
        }
        confirmLabel="Bekapcsolás"
        reason={{
          label: "Miért küldünk párhuzamosan?",
          placeholder: "pl. tulajdonosi döntés, 10-23: az első küldések a Klaviyo mellett",
          max: NOTE_MAX,
        }}
        onConfirm={async (note) => {
          await setHandoverParallel(row.country, true, note);
          onDone(`${row.country}: párhuzamos, ${PARALLEL}.`);
        }}
      />
    );
  }
  return (
    <ActionDialog
      open={open}
      onOpenChange={onOpenChange}
      title={`${row.country}: átadás-szűrés vissza`}
      description={
        <>
          Innen újra csak a szinkronizált, legfeljebb N. hullámos kontaktoknak küldünk (N ={" "}
          {row.wave}) — a futó kampányok is, a következő adagtól és a következő levéltől. Előbb a
          Klaviyóban zárd ki az <span className="data-mono">emc_wave ≤ N</span> profilokat, ha még
          nem tetted.
        </>
      }
      confirmLabel="Kikapcsolás"
      reason={{
        label: "Miért áll vissza az átadás-szűrés?",
        placeholder: "pl. Klaviyo HU: emc_wave <= 1 kizárva a kampányokból",
        max: NOTE_MAX,
      }}
      onConfirm={async (note) => {
        await setHandoverParallel(row.country, false, note);
        onDone(`${row.country}: újra átadás alatt, N = ${row.wave}.`);
      }}
    />
  );
}
